import {isObjectNullOrEmpty} from "../../Utilities/Types/objectUtilities";

export function isValidUser(user: Record<string, unknown> | null | undefined): boolean {
return !isObjectNullOrEmpty(user) && !!(user as Record<string, unknown>)?.userId;
}
